module.exports = __webpack_public_path__ + "images/emoji/u6e80.5ac982379c4c3ded2591.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/u6e80.png
// module id = N6Q7
// module chunks = 14